<template>
  <div class="yazdirtable">
    <div v-for="d in Veri.Daire">
      <div class="isletmedefteri">
        <ul class="isletmelist">
          <div class="row">
            <div class="col-6">
              <div class="cift-border">
                <img v-if="Logo" :src="'https://cdn.mudu.pro/Drive/upload/1/Genel/'+Logo" width="150"
                     class="pull-left">
                <img v-if="!Logo" src="https://cdn.mudu.pro/Design/logo.svg" width="150" class="pull-left">
                <div class=" col-lg-4 col-md-4 col-sm-4 col-xs-4 pull-right text-right">
                  <b>{{ Veri.Donem.Bina.Adi }}</b><br>
                  Bina İşletme Projesi<br> {{ Veri.Donem.tarih }}
                </div>
                <div class="clearfix"></div>
                <div class="text-center"><br> <b>{{ Veri.Donem.Bina.Adi }} {{ Veri.Donem.basTarihiText }} -
                  {{ Veri.Donem.bitTarihiText }} Dönemi Bina İşletme
                  Projesi'dir. </b> <br>
                </div>
                <div class="text-center"><p style="margin:0 !important;font-size: 14px;font-weight: bold">Sayın:
                  {{ d.AdSoyad }}</p>
                  {{ Veri.Donem.Bina.Adres }}
                  {{ d.Kat }}.Kat Kapı No:{{ d.kNo }}
                  {{ Veri.Donem.Bina.Sehir }}
                </div>
                <br><br>
                <div style="text-indent:20px;"> Apartmanınızın {{ Veri.Donem.KararDefteri.OTarihi }} tarihinde yapılan
                  Kat
                  malikleri genel kurulunda ; {{ Veri.Donem.KararDefteri.GKTarihi }} Tarih
                  ve {{ Veri.Donem.KararDefteri.yNo }} Yevmiye nolu
                  {{ Veri.Donem.KararDefteri.Noter }}nden tasdikli
                  karar defterinizin {{ Veri.Donem.KararDefteri.KSNo }} nolu sayfalarındaki karar ile
                  alınan yetkiye istinaden aşağıdaki kararlar alınmıştır.
                </div>
                <li> Apartmanınızın tahsilat işi
                  ; {{ Veri.Donem.basTarihiText }} - {{ Veri.Donem.bitTarihiText }} dönemi için
                  {{ Veri.HesapAyar.Unvan }}'ne yetki verilmiştir.
                </li>
                <li> Bina Yönetiminiz ; {{ Veri.Donem.Yonetim.Yonetici }}, {{ Veri.Donem.Yonetim.Vekil }} ,
                  {{ Veri.Donem.Yonetim.Uye }} ve Denetçi {{ Veri.Donem.Yonetim.Denetci }} seçili
                  olup, {{ Veri.Donem.Yonetim.Yonetici }} Yönetim Kurulu Başkanı'dır.
                </li>
                <li> Aidatlar
                  ofisimize bizzat gelerek nakit veya kredi kartı,
                  banka hesaplarımıza veya internet sitemiz üzerinden online ödeme yapılacaktır.
                  Vadesine kadar ödenmeyen aidatlara aylık % 5. gecikme
                  tazminatı uygulanacaktır.
                  Zamanında ödenmeyen aidatlar için yönetime ve bina sakinlerine ayrıca bilgi
                  vermeye gerek olmaksızın icra takibi başlatılacaktır.
                  Ödemeler T.B.K. m.100 gereğince öncelikle gecikme zamlarına sayılacaktır.
                </li>
                <li> Piyasa durum ve mevsim şartlarına göre aidat yetersiz kalır ve demirbaş
                  harcamaları olursa aşağıdaki miktarlara ekleme yapılacaktır.
                </li>
                <li> Yapılacak olan demirbaş harcamalarının ödemelerini kiracılar yapacak, Mesken
                  sahiplerinden talepte bulunacaklardır.
                </li>
                <li> Kesinlik kazanmış İşletme Projesi İCRA İFLAS KANUNU'nun 68. maddesinde
                  belirtilen belgelerden sayılır.
                </li>
                <li> Genel giderlere katılım hususunda K.M.K m.20 doğal olarak uygulanacak olup aidat
                  borçlarından K.M.K.m. 18/2 uyarınca Mesken sahipleri ile kiracılar müştereken
                  malikle birlikte yeni malik müştereken ve müteselsilen sorumludur.
                </li>
                <li> Meskenden ayrılan kiracıların borç ve alacaklarından Mesken sahibi sorumludur.
                </li>
                <li> Ödenmeyen aidatlarla ilgili icra işlemi yapıldığında yönetime ve firmamıza neden
                  bilgi vermediniz diye sorulmayacaktır.
                </li>
                <li> Bu işletme projesinde belirtmiş olduğum TC Kimlik no ve telefon numaralarının
                  tarafıma ait olduğunu onaylarım.
                </li>
                <li> Önceki dönemden borcu bulunanların bu borçlarını işletme projesinin tebliğ
                  tarihinden yedi gün içerisinde ödemeleri gerekmektedir. Aşağıda yazılı olan eski
                  borç işbu işletme projesiyle kesinlik kazanacak ve icra takibine konu edilebilir
                  hale gelecek olup itiraz olunmayacaktır.
                </li>
                <li> Yönetici firma gerek üçüncü şahıslara gerekse bina sakinlerine karşı dava açmaya
                  yetkilidir.
                </li>
                <li> Vadesinde ödenmeyen aidatlara aylık % 5. gecikme
                  tazminatı uygulanarak yatırılacak, eksik yatırılan yönetici de olsa İCRA
                  takibine muhatap olacaktır.
                </li>
                <li> Bağımsız bölüme oturan ve ayrılan bina sakinleri bu durumlarını firmaya ve
                  Mesken sahiplerine bildireceklerdir. Bağımsız bölüme yeni oturan bina sakini
                  öncelikle binaya olan borçtan sorumlu olacak, ayrılacak bina sakini ise
                  öncelikle binaya olan borcunu kapatacaktır.
                </li>
                <li> İcra işlemlerinden dolayı ödenecek olan gecikme zamlarının kaldırılması
                  hususunda yönetim veya firmamız sorumlu değildir. Bu hususta tek yetkili kat
                  malikleri genel kuruludur.
                </li>
                <li> Ödemeler T.B.K. m.100 gereğince öncelikle gecikme tazminatı ve fer'ilere mahsup
                  olunacaktır.
                </li>
              </div>
            </div>
            <div class="col-6">
              <div class="cift-border">
                <li v-if="Veri.Donem.KararDefteri.OzelMadde">{{ Veri.Donem.KararDefteri.OzelMadde }}</li>
                <li>Apartmanınıza
                  ait {{ Veri.Donem.basTarihiText }} - {{ Veri.Donem.bitTarihiText }} Dönemi Bina İşletme Projesi.
                  <br>
                  <table class="isletmetable table table-bordered">
                    <thead>
                    <tr>
                      <th width="60%">Tahmini Gider Bütçe Oluşumu</th>
                      <th width="20%" class="text-right">Aylık</th>
                      <th width="20%" class="text-right">Yıllık</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="g in Veri.Gider">
                      <td>{{ g.Kategori }}</td>
                      <td class="text-right">{{ g.Tutar }}<sup>TL</sup></td>
                      <td class="text-right">{{ g.TutarY }}<sup>TL</sup></td>
                    </tr>
                    <tr>
                      <th>GENEL TOPLAM</th>
                      <th class="text-right">{{ Veri.AltToplam.Tutar }}<sup>TL</sup></th>
                      <th class="text-right">{{ Veri.AltToplam.TutarY }}<sup>TL</sup></th>
                    </tr>
                    </tbody>
                  </table>
                </li>
                <li>Ödemeler aşağıdaki şekilde belirlenmiştir.<br>
                  <div class="row">
                    <div class="col-6 p-l-0">
                      <table class="isletmetable table table-bordered">
                        <thead>
                        <tr>
                          <th width="80%">Ödeme Dönemi</th>
                          <th width="20%" class="text-right">Tutar</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="i in (Veri.Donem.ay/2)">
                          <td>{{ Veri.Borc[i] }}</td>
                          <td class="text-right">{{ Veri.Donem.BorclandirmaYaz }}<sup>TL</sup></td>
                        </tr>

                        </tbody>
                      </table>
                    </div>
                    <div class="col-6 p-l-0">
                      <table class="isletmetable table table-bordered">
                        <thead>
                        <tr>
                          <th width="80%">Ödeme Dönemi</th>
                          <th width="20%" class="text-right">Tutar</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="i in (Veri.Donem.ay/2)">
                          <td>{{ Veri.Borc[i + Veri.Donem.ay / 2] }}</td>
                          <td class="text-right">{{ Veri.Donem.BorclandirmaYaz }}<sup>TL</sup></td>
                        </tr>
                        </tbody>
                        <tbody>
                        <tr>
                          <th width="80%"><b>GENEL TOPLAM</b></th>
                          <th width="20%" class="text-right"><b>{{ Veri.BorcToplam }}</b><sup>TL</sup></th>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="clearfix"></div>
                </li>
                <li> Daire malik ve sakinine ait istenilen bilgiler,<br>
                  <table class="table table-bordered">
                    <thead>
                    <tr>
                      <th width="30%" style="font-size: 9px !important;">İSTENİLEN BİLGİ</th>
                      <th width="35%" style="font-size: 9px !important;" class="text-center">SAKİN</th>
                      <th width="35%" style="font-size: 9px !important;" class="text-center">MALİK</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <th>ADI SOYADI</th>
                      <th style="border-right:1px solid #e4e7ea"></th>
                      <th></th>
                    </tr>
                    <tr>
                      <th>T.C. KİMLİK NO.</th>
                      <th style="border-right:1px solid #e4e7ea"></th>
                      <th></th>
                    </tr>
                    <tr>
                      <th>EV TELEFONU</th>
                      <th style="border-right:1px solid #e4e7ea"></th>
                      <th></th>
                    </tr>
                    <tr>
                      <th>İŞ TELEFONU</th>
                      <th style="border-right:1px solid #e4e7ea"></th>
                      <th></th>
                    </tr>
                    <tr>
                      <th>CEP TELEFONU</th>
                      <th style="border-right:1px solid #e4e7ea"></th>
                      <th></th>
                    </tr>
                    </tbody>
                  </table>
                </li>
                <div class="row">
                  <div class="text-center col-6"> TEBLİĞ EDEN<br><br><br></div>
                  <div class="text-center col-6"> TEBELLÜĞ EDEN<br><br><br></div>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </ul>
      </div>
      <div class="sayfasonu"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['Veri'],
  data() {
    return {
      Logo: null
    }
  },
  methods: {
    Yazdir() {

    },
  },
  created() {
    setTimeout(() => {
      window.print();
      this.$emit('Yazdirildi', this.ProjeDetay);
    }, 100);
    this.Logo = JSON.parse(localStorage.getItem('_aiHizmet'))['Logo'];
  }
}
</script>

<style scoped>
.isletmedefteri {
  max-height: 700px;
  background: #fff;
  padding: 20px 0 0;
  font-size: 9px !important;
  margin-bottom: 30px;
}

ul.isletmelist {
  list-style-type: decimal-leading-zero;
  text-align: left;
  margin: 0;
  padding: 0;
}

.cift-border {
  border: 5px double #000;
  padding: 5px;
  height: 690px;
}

ul.isletmelist li {
  padding: 1px 0;
  text-align: left;
  margin-left: 20px;
}

.isletmetable {
  margin: 10px -10px;
}

.isletmetable.table > tbody > tr > td, .isletmetable.table > tbody > tr > th, .isletmetable.table > thead > tr > th {
  font-size: 9px !important;
  padding: 2px 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pack/Genel/IsletmeProjesiYazdir.vue